import './Footer.module.scss';

const Footer = () => {
    return (
        <div style={{fontFamily: "Rubik", opacity: 0.5, width: "100%", textAlign: "center"}}>
            <p style={{fontSize: "12px", lineHeight: "24px"}}>
                <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">Terms of service</a>,&nbsp;
                <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>,&nbsp;and&nbsp;
                <a href={process.env.REACT_APP_SWEEPSTAKES_RULES_URL} target="_blank" rel="noreferrer" >Sweepstakes Rules</a><br/>
                    Powered by <a href="https://www.actv8me.com" target="_blank" rel="noreferrer">ACTV8me</a>
            </p>            
        </div>
    )
}

export default Footer;